<template>
  <div>
    <div class="sga-page-4 page-4">
      <h3>Work History</h3>
      <p style="margin-top: 20px">
        On this page, you can enter the details of your past job including
        entry-level jobs you have completed as a student, hobby, or volunteer
        work.
      </p>
      <el-form @submit.native.prevent style="margin-top: 40px">
        <el-form-item id="workhistorydetails">
          <el-alert v-if="sgaWorkHistory.userWorkHistory.length > 0"
            title="Please tick the checkboxes in each field if you want it to be visible in your resume or user details."
            type="success"
            :closable="false"
            show-icon
          >
          </el-alert>
          <div
            id=""
            v-for="(workhistorydetails,
            index) in sgaWorkHistory.userWorkHistory"
            :key="index"
          >
            <p>
              <i
                class="el-icon-remove delete_bachelorsdegreedetails"
                style="color: #dc3c3c; font-size: 20px"
                @click="removeWorkHistory(index)"
              ></i>
              &nbsp;&nbsp;&nbsp;&nbsp;Please enter your work experience below
            </p>
            <el-checkbox
              style="padding-top: 10px"
              v-model="workhistorydetails.employerVisible"
              >Employer Name</el-checkbox
            >
            <el-form-item>
              <el-input
                maxlength="100"
                type="text"
                v-model="workhistorydetails.employer"
              />
            </el-form-item>
            <el-form-item
              :error="
                retrieveFieldError(
                  modelState,
                  'Request.SgaWorkHistory.UserWorkHistory['+index+'].workDate'
                )
              "
            >
              <el-row style="height: 90px;">
                <el-col :xl="12" :lg="12">
                  <el-checkbox
                    style="padding-top: 10px"
                    v-model="workhistorydetails.workedFromVisible"
                    >Start Date</el-checkbox
                  ><br />
                  <el-date-picker
                    v-model="workhistorydetails.workedFrom"
                    type="date"
                    format="MM-dd-yyyy"
                    placeholder="Pick a date"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :xl="11" :lg="11">
                  <el-checkbox
                    style="padding-top: 10px"
                    v-model="workhistorydetails.workedToVisible"
                    >End Date</el-checkbox
                  ><br />
                  <el-date-picker
                    :disabled="workhistorydetails.workedToPresent"
                    v-model="workhistorydetails.workedTo"
                    type="date"
                    format="MM-dd-yyyy"
                    placeholder="Pick a date"
                  >
                  </el-date-picker>
                  <el-checkbox
                    v-model="workhistorydetails.workedToPresent"
                    @change="workhistorydetails.workedTo = null"
                    style="padding-left: 15px"
                    ><p>To Present</p></el-checkbox
                  >
                </el-col>
              </el-row>
            </el-form-item>
            <el-checkbox
              style="padding-top: 10px; margin-top: 30px;"
              v-model="workhistorydetails.jobTitleVisible"
              >Job Title</el-checkbox
            >
            <el-form-item :error="
                retrieveFieldError(
                  modelState,
                  'Request.SgaWorkHistory.UserWorkHistory['+index+'].JobTitle'
                )
              ">
              <el-input
                maxlength="100"
                type="text"
                v-model="workhistorydetails.jobTitle"
              />
            </el-form-item>
            <el-checkbox
              style="padding-top: 10px"
              v-model="workhistorydetails.employerAddressVisible"
              >Employer Address</el-checkbox
            >
            <el-form-item>
              <el-input
                maxlength="200"
                type="text"
                v-model="workhistorydetails.employerAddress"
              />
            </el-form-item>
            <el-checkbox
              style="padding-top: 10px"
              v-model="workhistorydetails.employerNumberVisible"
              >Employer Phone Number</el-checkbox
            >

            <el-form-item>
              <el-autocomplete
                style="width: 210px; padding-right: 10px"
                class="inline-input"
                v-model="workhistorydetails.selectedCountryCode"
                :fetch-suggestions="querySearch"
                placeholder="Type country"
                :trigger-on-focus="false"
                :clearable="true"
              >
                <template slot-scope="{ item }">
                  <el-tooltip placement="left">
                    <div slot="content">
                      <span>{{ item.value }}</span>
                    </div>
                    <span>{{ item.value }}</span>
                  </el-tooltip>
                </template>
              </el-autocomplete>

              <el-input
                maxlength="200"
                type="text"
                v-model="workhistorydetails.employerNumber"
                style="width: 350px; width: 200px"
              />
            </el-form-item>

            <el-form-item
              :error="
                retrieveFieldError(
                  modelState,
                  'Request.SgaWorkHistory.UserWorkHistory['+index+'].EmployerNumber'
                )
              "
            >
            </el-form-item>
            <hr
              class="ts-form-break"
              v-if="sgaWorkHistory.userWorkHistory.length > 1"
            />
          </div>
          <br />
          <button class="ts-btn ts-btn-white" @click.prevent="addWorkHistory">
            + Add Work Experience
          </button>
          <br />
          <button
            class="ts-btn ts-btn-rounded ts-btn-secondary"
            @click="storeSection()"
          >
            Continue
          </button>
          <a class="back-link" href="/sga/questionnaire/3">
            <i class="fas fa-chevron-left"></i>Back
          </a>
        </el-form-item>
      </el-form>
    </div>

    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      :page12="page12"
      currentPage="page4"
    >
    </questionnaire-print>
    <!-- <JobSeekerCV ref="cv" :Image="Base64Raw" :Data="currentSga" :UserInfo="currentUser" :ShowProfile="showProfile"></JobSeekerCV>  -->
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    ></JobSeekerCV>
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="displayResume"
    ></ResumeListSelection>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>
<script>
import $ from "jquery";
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";

export default {
  components: {
    QuestionnairePrint,
    JobSeekerCV,
    TSLoading,
    ResumeListSelection
  },
  created() {
    this.isLoading = true;
    this.$store.dispatch("sga/getsga").then(res => {
      if (this.currentSga.sgaEmployeeInfo != null) {
        this.sgaEmployeeInfo = this.currentSga.sgaEmployeeInfo;
      }
      if (this.currentSga.sgaWorkHistory != null) {
        this.sgaWorkHistory = Object.assign(
          this.sgaWorkHistory,
          res.sgaWorkHistory
        );

        let idx = 0;
        this.sgaWorkHistory.userWorkHistory.forEach(element => {
          if (element.workedFrom == "0001-01-01T00:00:00Z") {
            element.workedFrom = null;
          }
          if (element.workedTo == "0001-01-01T00:00:00Z") {
            element.workedTo = null;
          }
          idx++;
        });
      }
    })
    .finally(() => {
      this.isLoading = false;
    });

    if (sessionStorage.getItem("profilephoto")) {
      this.base64Raw = sessionStorage.getItem("profilephoto");
    }

    this.$store.dispatch("common/getCountries").then(res => {
      this.countries = res;
      if (this.workhistorydetails.employerNumber != "") {
        let country = {};
        if (this.$props.countryCode == "") {
          country =
            this.workhistorydetails.employerNumber.indexOf(" ") != -1
              ? this.countries.find(c =>
                  c.phoneCode.indexOf("+") === 0
                    ? c.phoneCode ===
                      this.workhistorydetails.employerNumber.split(" ")[0]
                    : c.phoneCode ===
                      this.workhistorydetails.employerNumber
                        .split(" ")[0]
                        .slice(1)
                )
              : null;
        } else {
          country = this.countries.find(c => c.code == this.$props.countryCode);
        }

        this.selectedCountry =
          country != null
            ? country.name +
              " | " +
              (country.phoneCode.indexOf("+") === 0
                ? country.phoneCode
                : "+" + country.phoneCode)
            : this.selectedCountry;
      }
    });
  },
  mounted() {
    this.$router.app.$on("questionnaire-print", this.printPage);
    // this.$router.app.$on('cv-print', this.printPageAsCV);
    this.$router.app.$on("show-resume-list", this.showResumeList);
  },
  destroyed() {
    if (
      this.$route.matched.find(c => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  data() {
    return {
      isLoading: false,
      showResumeListModal: false,
      modelState: {},
      base64Raw: null,
      showProfile: true,
      showProfilePhoto: true,
      sgaEmployeeInfo: {},
      sgaYourJob: {
        jobRole: {},
        JobDescriptionTasks: [],
        customTasks: []
      },
      sgaEducation: {
        secondLevelEducation: {
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: []
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          bachelorsDegreeDetails: []
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: []
        },
        sectorExperience: {
          experience: false,
          experienceDetails: []
        },
        naicsLevel1Options: {}
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaTechnologies: {
        selectedTechnologies: [],
        customTechnologies: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        commuteDistance: "",
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      cvCollection: [],
      workhistorydetails: {
        workedToPresent: false,
        selectedCountryCode: "United States | +1"
      },
      profile: {},
      profileSettings: [],
      countries: []
    };
  },
  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    page1() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
        : {};
    },
    page2() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2;
        } else {
          return {
            sgaYourJob: this.sgaYourJob,
            taskSearch: this.taskSearch,
            hiddenTasks: this.hiddenTasks
          };
        }
      } else {
        return {
          sgaYourJob: this.sgaYourJob,
          taskSearch: this.taskSearch,
          hiddenTasks: this.hiddenTasks
        };
      }
    },
    page3() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3;
        } else {
          return { sgaEducation: this.sgaEducation };
        }
      } else {
        return { sgaEducation: this.sgaEducation };
      }
    },
    page4() {
      this.sgaWorkHistory.userWorkHistory.forEach(element => {
        if (element.workedFrom == "0001-01-01T00:00:00") {
          element.workedFrom = null;
        }
        if (element.workedTo == "0001-01-01T00:00:00") {
          element.workedTo = null;
        }
      });
      return {
        sgaWorkHistory: this.sgaWorkHistory
      };
    },
    page5() {
      this.sgaCertifications.userCertifications.forEach(element => {
        if (element.acquiredDt == "0001-01-01T00:00:00") {
          element.acquiredDt = null;
        }
        if (element.expirationDt == "0001-01-01T00:00:00") {
          element.expirationDt = null;
        }
        if (element.image == undefined) {
          element.image = null;
        }
      });
      return {
        sgaCertifications: this.sgaCertifications,
        selectedCodeDetail: this.selectedCodeDetail
      };
    },
    page6() {
      return {
        sgaHiddenExtras: this.sgaHiddenExtras
      };
    },
    page7() {
      return {
        sgaKnowledge: this.sgaKnowledge
      };
    },
    page8() {
      return {
        sgaTechnologies: this.sgaTechnologies
      };
    },
    page9() {
      return {
        sgaMindset: this.sgaMindset
      };
    },
    page10() {
      return {
        sgaSkills: this.sgaSkills
      };
    },
    page11() {
      return {
        sgaHiddenTalents: this.sgaHiddenTalents
      };
    },
    page12() {
      return {
        sgaCulture: this.sgaCulture
      };
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var results = queryString
        ? this.countries
            .filter(
              c => c.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
            )
            .map(a => ({
              value:
                a.name +
                " | " +
                (a.phoneCode.indexOf("+") === 0
                  ? a.phoneCode
                  : "+" + a.phoneCode),
              data: a
            }))
        : this.countries;
      if (results.length === 0) {
        this.selectedPhoneCode = queryString;
      }
      cb(results);
    },
    closeResumeListModal() {
      this.showResumeListModal = false;
    },
    showResumeList() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res.filter(d => d.isActive == true);
          this.loading = false;
          this.showResumeListModal = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    displayResume(setting) {
      var obj = {
        userid: this.currentUser.id,
        cvid: setting.id
      };
      this.$store.dispatch("account/getprofiledetails", obj).then(res => {
        this.profile = res;
        this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
        this.closeResumeListModal();

        this.$refs.cv.showCV(true);
        // this.showProfile = true;
        this.$refs.questionnaire.hideQuestionnaire();
        var x = this.$refs.cv.hideCV;
        window.setTimeout(function() {
          // action();
          window.print();
          x();
        }, 500);
      });
    },
    addWorkHistory() {
      this.sgaWorkHistory.userWorkHistory.push({
        employer: null,
        workedFrom: null,
        workedTo: null,
        jobTitle: null,
        employerAddress: null,
        employerVisible: false,
        workedFromVisible: false,
        workedToVisible: false,
        jobTitleVisible: false,
        employerAddressVisible: false,
        employerNumber: null,
        employerNumberVisible: false
      });
    },
    removeWorkHistory(index) {
      this.sgaWorkHistory.userWorkHistory.splice(index, 1);
    },
    storeSection() {
      this.isLoading = true;
      this.modelState = {};
      this.currentSga.sgaWorkHistory = this.sgaWorkHistory;
      if (this.currentSga.sgaWorkHistory.id == null) {
          this.$store
            .dispatch("sga/postsga", this.currentSga)
            .then(() => {
              this.$router.app.$emit("navigateToNextStep");
            })
            .catch(res => {
              this.modelState = res;
              this.isLoading = false;
            })
            .finally(() => {
              this.isLoading = false;
            });
        } else {
          this.$store
            .dispatch("sga/putsga", this.currentSga)
            .then(() => {
              this.$router.app.$emit("navigateToNextStep");
            })
            .catch(res => {
              this.modelState = res;
              this.isLoading = false;
            })
            .finally(() => {
              this.isLoading = false;
            });
        }

      sessionStorage.setItem(
        "sgaDataForPrinting",
        JSON.stringify({
          page1: this.page1,
          page2: this.page2,
          page3: this.page3,
          page4: { sgaWorkHistory: this.currentSga.sgaWorkHistory }
        })
      );
    },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch("sga/getsga").then(data => {
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaEducation = data.sgaEducation || this.sgaEducation;
        this.sgaWorkHistory = this.sgaWorkHistory;
        this.sgaCertifications =
          data.sgaCertifications || this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;

        this.$store
          .dispatch("sga/getSGAforPrint", this.sgaHiddenExtras)
          .then(() => {
            this.$refs.cv.hideCV();
            this.$refs.questionnaire.showQuestionnaire();
            action();
            this.$refs.questionnaire.hideQuestionnaire();
          });
      });
    },
    printPageAsCV(action) {
      this.cvCollection = [
        {
          userInfo: this.currentUser,
          image: this.base64Raw,
          survey: this.currentSga
        }
      ];
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
        });
    },
    formatDate(d) {
      d = new Date(d);
      // you could also provide your own month names array
      //const months = this.$refs.datePicker.translation.months
      return `${d.getMonth()}-${d
        .getDate()
        .toString()
        .padStart(2, 0)}-${d.getFullYear()}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form-item
{
  height: 60px;
}
.cert-placeholder {
  height: 100%;
  width: 100%;
  background-color: #b8ccdf;
  color: white;
}
.reminder {
  -webkit-box-shadow: 0 0.15rem 0.15rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.15rem 0.15rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 40px;
  display: table;
  background-color: #cce5ff;
  .reminder-icon {
    padding: 5px 15px;
    border-radius: 0.5rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    display: table-cell;
    font-size: 20px;
    border-right: 0;
    background: #eef6ff;
    border: 2px solid #eef6ff;
    i {
      vertical-align: middle;
    }
  }
  .reminder-copy {
    padding: 8px;
    font-size: 14px;
    padding-left: 1rem;
    display: inline-block;
    color: #004085;
  }
}

.el-checkbox__inner {
  border-color: #000000 !important;
}

@media screen and (max-width: 759px) {
  .el-alert__content {
    line-height: 15px;
  }
}
</style>
